module.exports = __webpack_public_path__ + "static/media/w9.0973e7cf.jpg";